import { render, staticRenderFns } from "./ThanksView.vue?vue&type=template&id=55d359f4&scoped=true&"
import script from "./ThanksView.vue?vue&type=script&lang=js&"
export * from "./ThanksView.vue?vue&type=script&lang=js&"
import style0 from "./ThanksView.vue?vue&type=style&index=0&id=55d359f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d359f4",
  null
  
)

export default component.exports